module.exports = __webpack_public_path__ + "static/media/i_featured_info.d8e1b3ac.svg";